import { render, staticRenderFns } from "./Popover_Login.vue?vue&type=template&id=036b8d70&scoped=true&"
import script from "./Popover_Login.vue?vue&type=script&lang=js&"
export * from "./Popover_Login.vue?vue&type=script&lang=js&"
import style0 from "./Popover_Login.vue?vue&type=style&index=0&id=036b8d70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036b8d70",
  null
  
)

export default component.exports